import React, { Component } from 'react'
import { streamUrl } from '../../../variables/index'
import { strVal } from '../../../modules/Utils'
import { Card, Col, Row } from 'antd'
import IndvImage from '../../../assets/img/avatar_2.png'
import OrgImage from '../../../assets/img/employee.png'
import _ from 'lodash'
import ContactDetailsDisplay from './ContactDetailsDisplay'

class CardDetails extends Component {
  render() {
    const { member, handleOnRowClick, auth } = this.props
    const profileImage = {
      individual: IndvImage,
      organisation: OrgImage,
    }
    return (
      <Card
        style={{ width: 350, height: 300 }}
        title={
          <h3>
            <a onClick={handleOnRowClick}>{member.fn || '_NO_NAME_'}</a>
          </h3>
        }>
        <Row>
          <Col span={8} style={{ margin: 'auto' }}>
            <img
              src={
                member.image
                  ? `${streamUrl}files/${member.image}?action=view&access_token=${auth.getAccessToken()}`
                  : profileImage[member.kind]
              }
              style={
                member.image
                  ? {
                      maxHeight: '50px',
                      fontSize: '30pt',
                      background: 'white',
                    }
                  : { width: '50px', fontSize: '30pt', height: '50px' }
              }
            />
          </Col>
          <Col span={1} />
          {_.get(member, 'position') && <span>{strVal(member, 'position')}</span>}
        </Row>
        <Row>
          <Col span={24} style={{ marginTop: '15px' }}>
            <ContactDetailsDisplay member={member} />
          </Col>
        </Row>
      </Card>
    )
  }
}

CardDetails.propTypes = {}
CardDetails.defaultProps = {}

export default CardDetails
